export * from './font-awesome-icons';
